export const appRoutes = {
  auth: {
    login: '/login',
    forgotPassword: '/recuperar-senha',
    resetPassword: '/reset-password',
  },
  dashboard: '/dashboard',
  ajuda: '/ajuda',
  fazendas: {
    list: '/fazendas',
    view: (id: string) => `/fazendas/${id}`,
    edit: (id: string) => `/fazendas/${id}/editar`,
  },
  areas: {
    list: '/areas',
    view: (id: string) => `/areas/${id}`,
    edit: (id: string) => `/areas/${id}/editar`,
  },
  ingredientes: {
    list: '/ingredientes',
    view: (id: string) => `/ingredientes/${id}`,
    edit: (id: string) => `/ingredientes/${id}/editar`,
  },
  formulas: {
    list: '/formulas',
    view: (id: string) => `/formulas/${id}`,
    edit: (id: string) => `/formulas/${id}/editar`,
  },
  programas: {
    list: '/programas',
    view: (id: string) => `/programas/${id}`,
    edit: (id: string) => `/programas/${id}/editar`,
  },
  curvasDeGanho: {
    list: '/curvas-de-ganho',
    view: (id: string) => `/curvas-de-ganho/${id}`,
    edit: (id: string) => `/curvas-de-ganho/${id}/editar`,
  },
  lotes: {
    list: '/lotes',
    view: (id: string) => `/lotes/${id}`,
    edit: (id: string) => `/lotes/${id}/editar`,
  },
  animais: {
    list: '/animais',
  },
  movimentacoes: {
    list: '/movimentacoes',
  },
  contratos: {
    list: '/contratos',
    view: (id: string) => `/contratos/${id}`,
  },
  manejo: {
    list: '/manejo',
  },
  pasto: '/pasto',
  nutricao: {
    list: '/nutricao',
    view: (date: string) => `/nutricao/${date}`,
    ajusteDiario: (date: string) => `/nutricao/${date}/ajuste-diario`,
  },
  cocho: {
    list: '/cocho',
    area: (areaId: string) => `/cocho/areas/${areaId}`,
    areaAt: (areaId: string, date: string) => `/cocho/areas/${areaId}?date=${date}`,
  },
  producao: {
    list: '/producao',
    nova: '/producao/nova',
    view: (id: string) => `/producao/${id}`,
  },
  estoque: '/estoque',
  financas: {
    list: '/financas',
    view: (id: string) => `/financas/${id}`,
  },
  financasDetalhe: '/financas-detalhe',
  transferencias: {
    list: '/transferencias',
    receber: (id: string) => `/transferencias/${id}/receber`,
  },
  fornecedores: {
    list: '/fornecedores',
    view: (id: string) => `/fornecedores/${id}`,
    edit: (id: string) => `/fornecedores/${id}/editar`,
  },
  compradores: {
    list: '/compradores',
    view: (id: string) => `/compradores/${id}`,
    edit: (id: string) => `/compradores/${id}/editar`,
  },
  usuarios: {
    list: '/usuarios',
    view: (id: string) => `/usuarios/${id}`,
    edit: (id: string) => `/usuarios/${id}/editar`,
  },
  licencas: '/licencas',
  relatorios: '/relatorios',
  avaliacoes: {
    list: '/saidas',
    edit: (id: string) => `/saidas/${id}/editar`,
  },
  operacao: {
    list: '/operacao',
  },
  automacao: {
    list: '/automacao',
    // Rota técnica, separada do cadastro do gestor (seção 22 do plano):
    // perfil de equipamento é decisão de quem homologa, não de quem planeja.
    perfisTecnicos: '/automacao/perfis-tecnicos',
  },
  sanitario: {
    list: '/sanitario',
    productView: (id: string) => `/sanitario/produtos/${id}`,
    productEdit: (id: string) => `/sanitario/produtos/${id}/editar`,
  },
} as const;
